import React from "react";
import ContentLoader from "react-content-loader";
import PustackShimmer from '../global/Shimmer';

export default function PollCardShimmer({ isDarkMode, isSmallScreen }) {
	return (
		<div className="poll__shimmer">
			{!isSmallScreen && <PustackShimmer style={{borderRadius: '0px', width: '100%', height: '200px'}}/>}
		</div>
	);
}
